import { render, staticRenderFns } from "./CommentReactions.vue?vue&type=template&id=52793121&scoped=true&"
import script from "./CommentReactions.vue?vue&type=script&lang=js&"
export * from "./CommentReactions.vue?vue&type=script&lang=js&"
import style0 from "./CommentReactions.vue?vue&type=style&index=0&id=52793121&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52793121",
  null
  
)

export default component.exports